import React, { useEffect, useState } from "react"
import { Col, Container, Row } from "react-bootstrap"
import "./signup.css"
import signupimage from "../../img/signupimage.png"
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup"
import { useForm } from "react-hook-form"
import { FormInput, FormSelect } from "../form"
import { COUNTRY_LIST } from "../../constants"
import { Form, Button } from "react-bootstrap"
import { useRegisterUserMutation } from "../../services/authServices"
import { toast } from "react-toastify"
import { useNavigate, useParams } from "react-router-dom"
import { FaEye } from "react-icons/fa"
import Signin from "../signin"
interface signUpProps {}

interface SignUpUser {
  firstname: string
  lastname: string
  email: string
  contactNo: string
  region: any
  address: string
  password: string
  confirmedPassword: string
  username?: string
}

const Signup2 = (props: signUpProps) => {
  const [signInModal, setSignInModal] = useState<boolean>(false)

  const navigate = useNavigate()
  const [submitForm, { isError, error, data }] = useRegisterUserMutation()
  const [show, setShow] = useState(false)

  const schemaResolver = yupResolver(
    yup.object().shape({
      firstname: yup.string().required("Please enter first name"),
      lastname: yup.string().required("Please enter last name"),
      email: yup.string().email().required("Please enter an email"),
      contactNo: yup.string().required("Please enter a valid phone no"),
      region: yup.mixed().required("Please select a region"),
      address: yup.string().required("Please enter your address"),
      password: yup
        .string()
        .required("Please fill in a password")
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
          "Invalid password format (Minimum 8 characters, at least one uppercase, one lowercase, and one number)",
        ),
      confirmedPassword: yup
        .string()
        .label("confirm password")
        .required()
        .oneOf([yup.ref("password"), ""], "Passwords must match"),
    }),
  )

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<SignUpUser>({
    resolver: schemaResolver,
  })

  const onSubmit = async (values: any) => {
    const payload = {
      firstName: values.firstname,
      lastName: values.lastname,
      email: values.email,
      contactNo: values.contactNo,
      address: values.address,
      region: values.region?.value,
      password: values.password,
      username: Math.random(),
    }
    submitForm(payload)
  }

  // useEffect(() => {
  //     if (error) {
  //         toast.error((error as any).data?.message, { toastId: 44 });
  //     }
  // }, [isError, error]);

  useEffect(() => {
    if (data?.message) {
      toast.success(data?.message, { toastId: 1 })
      navigate("/")
    }
  }, [data])

  return (
    <>
      <Container>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="signin-form">
            <Row>
              <Col md={5}>
                <div className="form-content">
                  <div className="form-heading">
                    <h1>Sign-up</h1>
                  </div>
                  <div className="signup-form mb-3">
                    <div className="w-100 me-2">
                      <FormInput
                        name="firstname"
                        title="First Name"
                        placeholder="John"
                        register={register}
                        errors={errors}
                      />
                    </div>
                    <div className="w-100 i-spece-two">
                      <FormInput
                        name="lastname"
                        title="Last Name"
                        placeholder="Doe"
                        register={register}
                        errors={errors}
                      />
                    </div>
                  </div>
                  <div className="emailform mb-3">
                    <FormInput
                      name="email"
                      title="Email ID"
                      placeholder="sample@sample.com"
                      register={register}
                      errors={errors}
                    />
                  </div>
                  <div className="phonenumber2 mb-3">
                    <FormInput
                      name="contactNo"
                      title="Contact No"
                      type="number"
                      placeholder="00000 00000"
                      register={register}
                      errors={errors}
                    />
                  </div>
                  <div className="emailform mb-3">
                    <FormSelect
                      name="region"
                      className="region-selectbox"
                      title="Region"
                      control={control}
                      options={COUNTRY_LIST.map((x) => ({
                        label: x.name,
                        value: x.code,
                      }))}
                      errors={errors}
                      placeholder="Please select a region"
                    />
                  </div>
                  <div className="passwordform">
                    <FormInput
                      name="address"
                      title="Address"
                      placeholder="#ABC, #Street"
                      register={register}
                      errors={errors}
                    />
                  </div>
                  <div className="signup-form">
                    <div className="w-100 me-2 passwordinput position-relative">
                      <FormInput
                        name="password"
                        title="Password"
                        type={!show ? "password" : "text"}
                        placeholder="********"
                        register={register}
                        className="password-wrapper"
                        errors={errors}
                      />
                      <div
                        className="password-toggle-icon"
                        onClick={() => setShow(!show)}
                      >
                        <FaEye />
                      </div>
                    </div>
                    <div className="w-100 passwordinput position-relative">
                      <FormInput
                        name="confirmedPassword"
                        title="Confirm Password"
                        type={!show ? "password" : "text"}
                        placeholder="********"
                        register={register}
                        errors={errors}
                      />
                      <div
                        onClick={() => setShow(!show)}
                        className="password-toggle-icon"
                      >
                        <FaEye />
                      </div>
                      {/* <p onClick={() => setShow(!show)}>Show Password</p> */}
                    </div>
                  </div>
                  <div className="signup-button d-flex justify-content-between">
                    <div className="signup2">
                      <Button
                        size="lg"
                        variant="success"
                        type="submit"
                        className="my-3 w-100"
                      >
                        Sign Up
                      </Button>
                    </div>
                    <div className="signup2">
                      <Button
                        size="lg"
                        variant="success"
                        className="my-3 w-100"
                        onClick={() => setSignInModal(true)}
                      >
                        Login
                      </Button>
                    </div>
                  </div>
                </div>
              </Col>
              <Col md={1}></Col>
              <Col md={6}>
                <div className="signup-image">
                  <img src={signupimage} className="img-fluid" />
                </div>
              </Col>
            </Row>
          </div>
        </Form>
        <Signin show={signInModal} onHide={() => setSignInModal(false)} />
      </Container>
    </>
  )
}

export default Signup2
